import { render, staticRenderFns } from "./AchievementGem.vue?vue&type=template&id=7f3c49a8&scoped=true&"
import script from "./AchievementGem.vue?vue&type=script&lang=js&"
export * from "./AchievementGem.vue?vue&type=script&lang=js&"
import style0 from "./AchievementGem.vue?vue&type=style&index=0&id=7f3c49a8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f3c49a8",
  null
  
)

export default component.exports